import { TransportInsuranceRequestResult } from '@app/service/eshop/transport/actions/requestTransportInsurance';

interface Props {
    requestResult: TransportInsuranceRequestResult;
}

export function TransportHiddenInputs({ requestResult }: Props) {
    return (
        <>
            <input type="hidden" name="modelMTPL" value={requestResult.vehicleInformation.modelMTPL || ''} />
            <input type="hidden" name="modelCASCO" value={requestResult.vehicleInformation.modelCASCO || ''} />
            <input
                type="hidden"
                name="modificationCodeMTPL"
                value={requestResult.vehicleInformation.modificationCodeMtpl || ''}
            />
            <input
                type="hidden"
                name="deductiblePackageCodeMTPL"
                value={requestResult.vehicleInformation.deductiblePackageCodeMtpl || ''}
            />
            <input
                type="hidden"
                name="modificationCodeCasco"
                value={requestResult.vehicleInformation.modificationCodeCasco || ''}
            />
            <input
                type="hidden"
                name="deductiblePackageCodeCasco"
                value={requestResult.vehicleInformation.deductiblePackageCodeCasco || ''}
            />
            <input type="hidden" name="code" value={requestResult.personalCode} />
            <input
                type="hidden"
                name="manufactureYear"
                value={requestResult.vehicleInformation.manufactureYear?.toString() ?? ''}
            />
            <input type="hidden" name="licencePlate" value={requestResult.vehicleInformation.licencePlate} />
        </>
    );
}
